var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.messages)?_c('div',[_c('h2',{staticClass:"h4"},[_vm._v(_vm._s(_vm.messages['fh.kautionszahlung.weiterleitung']))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }